import Loadable from 'react-loadable';
import ComponentLoading from 'components/ComponentLoading/ComponentLoading';
var LoadableAdsDashboard = Loadable({
  loader: function loader() {
    return import('../AdsDashboard.jsx');
  },
  loading: ComponentLoading
});
export default LoadableAdsDashboard;